import { connect } from 'react-redux';
import { IAppState } from 'types/appState.type';
import { StepNavigator, IStepNavigatorProps } from './StepNavigator';
import {
	setShowCallToAction,
	setFocusElementAction,
} from 'actions/project.action';
import { IFocusElement } from 'types/project.type';

const mapStateToProps = (state: IAppState): IAppState => {
	return { ...state };
};

const mapDispatchToProps = (dispatch: any): IStepNavigatorProps => {
	return {
		setShowCallToAction: (showCallToAction: boolean) => {
			dispatch(setShowCallToAction(showCallToAction));
		},
		setFocusElementAction: (focusElement: IFocusElement) => {
			dispatch(setFocusElementAction(focusElement));
		},
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(StepNavigator);
